import ComponentBasePrototype from 'ComponentBasePrototype';
import RequestUtils from '../../../base/request/request';
import Cookies from 'cookies';
import Config from '../../../base/pride.config';
import WindowUtils from '../../../base/ui/window';
import _ from 'lodash';
import $ from 'jquery';

export default class BottomNotification extends ComponentBasePrototype {
  build() {
    this.hideIconIfLinkNotExist();
    this.currentHeight = 0;
    this.cookieName = this.node.data('cookiename');
    this.resizeHandler = this.getResizeHandler();
    const urlParam = this.node.data('parameter');
    const urlParamValue = this.node.data('parametervalue');

    this.addDeleteHandler(urlParam, urlParamValue);

    if (typeof Cookies.get(this.cookieName) === 'undefined' || Config.editorMode === true) {
      // Check if notification is associated to url parameters
      if (urlParam && urlParamValue && urlParam.length > 0 && urlParamValue.length > 0) {
        const urlParams = RequestUtils.getQueryParams();

        // No url parameters present, don't show the notification
        if (_.isEmpty(urlParams)) {
          return;
        }

        // Url parameters don't match the notification parameters, don't show the notification
        if (!urlParams[urlParam] || urlParamValue !== urlParams[urlParam]) {
          return;
        }
      }

      this.node.removeClass('notification--deleted');

      this.node.on(WindowUtils.whichTransitionEvent(), () => {
        this.publishNewHeight();
      });

      this.addResizeHandler();
    }
    this.hideDeletedNotification();
  }

  addDeleteHandler(urlParam, urlParamValue) {
    this.node.find('.deleteNotification').on('click', () => {
      this.eventBus.publish('notification_height_change', this.node.height() * -1);
      this.node.addClass('notification--deleted');
      this.node.attr('aria-hidden', 'true'); // sets aria hidden to true when notification is closed so screen readers don't read it
      this.disableTabbing(this.node); // calls method to disable tabbing for the notification i.e., article
      this.removeResizeHandler();

      // Set closed cookie only if there is no url parameters associated to the notification
      if (!urlParam || !urlParamValue || (urlParam.length === 0 && urlParamValue.length === 0)) {
        // one year in secs
        const year = 60 * 60 * 24 * 365;
        Cookies.set(this.cookieName, 'closed', { expires: year });
      }
    });
  }

  hideDeletedNotification() {
    // Disable tabbing for already deleted notifications
    if (this.node.hasClass('notification--deleted')) {
      this.disableTabbing(this.node);
      this.node.attr('aria-hidden', 'true'); 
    }
  }

  disableTabbing(element) {
  element.attr('tabindex', '-1');
  }


  addResizeHandler() {
    $(window).on('resize', this.resizeHandler);
  }

  removeResizeHandler() {
    $(window).off('resize', this.resizeHandler);
  }

  getResizeHandler() {
    return _.debounce(() => {
      // So we tell whoever's listening to remove the old height of the notification and add the new height in the publishNewHeight function.
      this.eventBus.publish('notification_height_change', this.currentHeight * -1);
      this.publishNewHeight();
    }, 250);
  }

  publishNewHeight() {
    this.currentHeight = this.node.height();

    if (this.currentHeight > 0) {
      this.eventBus.publish('notification_height_change', this.node.height());
    }
  }

  hideIconIfLinkNotExist() {
    if (this.node.find('.notification__text-content a').length < 1) {
      this.node.find('.notification__link').addClass('notification__link--hidden');

      // if notification does not contain link,
      // we can increase text content area to whole grid_col
      this.node.find('.notification__text-content').addClass('notification__text-content--padding-none');
    }
  }
}